import React from "react";
import "./customButton.css";
import { isMobile, isMobileOnly } from "react-device-detect";

const CustomButton = ({ text, onClick, type, isGcse, disabled }) => {
  if (type === "testPage") {
    return (
      <button
        onClick={onClick}
        className={`px-6 py-2 w-auto ${
          isGcse ? "border-radius-gcse" : "border-radius"
        } button-bg-colour  text-white`}
      >
        {!isMobile && <h3 className="text"> {text}</h3>}
        {isMobile && <p>{text}</p>}
      </button>
    );
  }

  if (type === "next") {
    return (
      <button
        onClick={onClick}
        className={`${
          isMobile
            ? "px-6 py-2 w-auto"
            : "px-6 py-2 w-auto button-bg-colour rounded-3xl text-white"
        } ${isGcse ? "next-button-gcse" : "next-button"} text-white `}
      >
        {!isMobile && <h3 className="text"> {text}</h3>}
        {isMobile && <p>{text}</p>}
      </button>
    );
  }

  if (type === "finish") {
    return (
      <button
        onClick={onClick}
        className="px-6 py-2 w-auto finish-button text-white  "
      >
        {!isMobile && <h3 className="text"> {text}</h3>}
        {isMobile && <p>{text}</p>}
      </button>
    );
  }

  if (type === "pass") {
    return (
      <button
        onClick={onClick}
        className={`${
          isMobile
            ? "px-6 py-2 w-auto"
            : "px-6 py-2 w-auto button-bg-colour rounded-3xl text-white"
        } ${isGcse ? "pass-button-gcse" : "pass-button"} text-white`}
      >
        {!isMobile && <h3 className="text"> {text}</h3>}
        {isMobile && <p>{text}</p>}
      </button>
    );
  }

  if (type === "logOut") {
    return (
      <button
        onClick={onClick}
        disabled={disabled}
        style={{ 
          pointerEvents: disabled ? 'none' : 'auto',
          cursor: disabled ? 'not-allowed' : 'pointer',
          position: 'relative',
          zIndex: 10
        }}
        className={`px-10 py-3 w-auto button-bg-colour rounded-3xl text-white whitespace-nowrap ${
          isGcse ? "border-radius-gcse" : "border-radius"
        } ${disabled ? 'opacity-50' : ''}`}
      >
        <p> {text}</p>
      </button>
    );
  }

  return (
    <button
      onClick={onClick}
      disabled={disabled}
      onKeyDown={(e) => {
        if (e.key === "Enter" && !disabled) {
          onClick();
        }
      }}
      style={{ 
        pointerEvents: disabled ? 'none' : 'auto',
        cursor: disabled ? 'not-allowed' : 'pointer',
        position: 'relative',
        zIndex: 10
      }}
      className={`px-10 py-3 w-auto ${
        isGcse ? "border-radius-gcse" : "border-radius"
      } button-bg-colour text-white ${disabled ? 'opacity-50 cursor-not-allowed' : ''}`}
    >
      {!isMobile && <h3 className="text"> {text}</h3>}
      {isMobile && <p>{text}</p>}
    </button>
  );
};

export default CustomButton;
